/**
 * 这里是一些通用的校验逻辑
 */

/**
 * 校验手机号的逻辑
 * @param { String | Number } phone 需要校验的手机号
 * @param { Boolean } autoPrefix 是否自动补零
 * @returns { Boolean } true 校验通过 false 校验不通过 Incorrect mobile number format
 */
export function validatePhone(phone: string, autoPrefix = true) {
    const phoneReg = /^0[1-9]\d{8,9}$/;
    let mobile = String(phone).toString().trim();
    if (autoPrefix && mobile[0] !== '0') {
        mobile = `0${phone}`;
    }
    return phoneReg.test(mobile);
    // return phone[0] === '0' ? phoneReg.test(phone) : phoneReg.test(`0${phone}`);
}

/**
 * 校验短信验证码的逻辑
 * @param { String | Number } code 要校验的验证码
 * @returns { Boolean } true 校验通过 false 校验不通过
 */
export function validateSMSCode(code: string) {
    const codeReg = /^[0-9]{6}$/;
    return codeReg.test(String(code).toString().trim());
}

/**
 * 校验密码的逻辑 
 * @param { String } pwd 要校验的密码
 * @returns { Boolean } true 校验通过 false 校验不通过
 */
export function validatePwd(pwd: string) {
    return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(String(pwd).toString());
}

// 校验邮箱逻辑
export function validateEmail(email: string) {
    const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    return emailReg.test(String(email).toString().trim())
    
}
